import styled from 'styled-components';

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
`;

export const FormRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const Label = styled.div`
  padding: 0px 5px;
`
export const Field = styled.div`
  width: 125px;
`;

export const SubText = styled.div`
  font-size: 0.75em;
  text-align: justify;
`;
